import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

export default class InitiativesTableSourceSelectorComponent extends Component {
  @service betaToggle;
  @service intl;

  @tracked tippyInstance = null;

  @action setTippyInstance(e) {
    this.tippyInstance = e;
  }

  get initiative() {
    return this.args.initiative;
  }

  get sourceOptions() {
    return this.betaToggle.sourceOptions;
  }

  @action
  handleSourceChange(initiative, e) {
    if (e === 'clear') initiative.source = null;
    else initiative.source = e;
    initiative.save();
  }

  get sourceOptionsLastIndex() {
    return this.sourceOptions.length - 1;
  }
}
